<template>
	<div>
		<v-form ref="boForm" v-model="valid">
			<v-container style="margin:0;">
				<v-layout row wrap>
					<v-flex
						v-for="(item, index) in items"
						:key="item.value + index"
						v-if="(!item.hide || !item.hide(model[item.value], model)) && (!disabled || model[item.value])"
						@click="item.click && item.click(model[item.value])"
						:xs12="
							item.type === 'sub-doc' ||
								item.type === 'sub-array' ||
								item.type === 'custom' ||
								item.type === 'text-area'
						"
						:xs3="
							item.type !== 'custom' &&
								item.type !== 'text-area' &&
								item.type !== 'sub-doc' &&
								item.type !== 'sub-array' &&
								item.type !== 'date' &&
								item.type !== 'time' &&
								item.type !== 'date-time'
						"
					>
						<div :is="item.component" @change="updateSub(item)" v-model="model[item.value]" :data="model" />

						<b-o-input
							ref="input"
							:input="item"
							v-model="model[item.value]"
							@change="update"
							v-if="item.type !== 'sub-doc' && item.type !== 'sub-array' && item.type !== 'custom'"
						></b-o-input>

						<sub-doc-input
							:ref="input"
							v-if="item.type === 'sub-doc'"
							:required="item.required"
							:disabled="item.disabled"
							:label="item.label"
							:rules="item.rules"
							@change="updateSub(item)"
							v-model="model[item.value]"
							:items="item.items"
						></sub-doc-input>

						<sub-array-input
							ref="input"
							v-if="item.type === 'sub-array'"
							:required="item.required"
							:disabled="item.disabled"
							:label="item.label"
							:rules="item.rules"
							@change="updateSub(item)"
							v-model="model[item.value]"
							:items="item.items"
						></sub-array-input>
					</v-flex>
				</v-layout>
			</v-container>
		</v-form>
		<v-btn color="info" :disabled="loading" @click="validate" v-if="!inputDisabled">
			Valider
			<v-progress-circular v-if="loading" indeterminate color="primary"></v-progress-circular>
		</v-btn>
	</div>
</template>
<script>
import BOInput from './boInput'
import SubDocInput from './inputs/subDocInput'
import SubArrayInput from './inputs/subArrayInput'

import { ERROR, SUCCESS } from '../variables'

export default {
	components: { BOInput, SubDocInput, SubArrayInput },
	props: ['value', 'disabled', 'noClear'],
	data() {
		return {
			items: [],
			model: {},
			loading: false,
			valid: false,
		}
	},
	methods: {
		async post() {},
		async put() {},
		init() {
			if (this.value !== undefined && this.value !== null) {
				this.model = this.value
			}

			// TODO : stroe previous value to call it back
			for (let i = 0; i < this.items.length; i++) {
				if (!this.items[i].isPrivateDisabledSet) {
					this.$set(this.items[i], 'privateDisabled', this.items[i].disabled)
					this.$set(this.items[i], 'isPrivateDisabledSet', true)
				}

				if (this.items[i].items && this.items[i].items.length > 0) {
					for (let j = 0; j < this.items[i].items.length; j++) {
						if (!this.items[i].items[j].isPrivateDisabledSet) {
							this.$set(this.items[i].items[j], 'privateDisabled', this.items[i].items[j].disabled)
							this.$set(this.items[i].items[j], 'isPrivateDisabledSet', true)
						}
					}
				}
			}
		},
		updateSub(item) {
			if (item.onChange) {
				item.onChange(this.model[item.value])
			}
			this.update()
		},
		update() {
			this.$emit('input', this.model)
			this.$emit('change', this.model)
		},
		validate() {
			this.$refs.boForm.resetValidation()
			if (!this.valid) {
				setTimeout(
					function() {
						this.$refs.boForm.validate()
					}.bind(this),
					200,
				)
			}
			if (this.valid) {
				this.loading = true
				if (this.model._id) {
					this.put(this.model)
						.then(() => {
							this.loading = false
							this.$store.dispatch(SUCCESS, 'Mise à jour réussie')
						})
						.catch((err) => {
							this.loading = false
							console.log(err)
							this.$store.dispatch(ERROR, err)
						})
				} else {
					this.post(this.model)
						.then(() => {
							this.loading = false
							this.$store.dispatch(SUCCESS, 'Création réussie')

							if (this.noClear !== true) {
								for (let i = 0; i < this.$refs.input.length; i++) {
									this.$refs.input[i].empty()
								}
								this.update()

								if (this.$refs.boForm) {
									this.$refs.boForm.resetValidation()
								}
							}
						})
						.catch((err) => {
							this.loading = false
							if (this.$refs.boForm) {
								this.$refs.boForm.resetValidation()
							}
							console.log(err)
							this.$store.dispatch(ERROR, err)
						})
				}
			}
		},
		updateDisabled() {
			let itemDisabled
			for (let i = 0; i < this.items.length; i++) {
				itemDisabled = this.items[i].privateDisabled
				if (typeof itemDisabled === 'function') {
					itemDisabled = itemDisabled()
				}

				this.$set(this.items[i], 'disabled', this.inputDisabled || itemDisabled)
			}
		},
	},
	computed: {
		inputDisabled() {
			if (this.disabled && typeof this.disabled === 'function') {
				return this.disabled()
			}
			return this.disabled
		},
	},
	watch: {
		inputDisabled() {
			this.updateDisabled()
		},
		value() {
			this.init()
		},
	},
	mounted() {
		this.init()
		this.updateDisabled()
	},
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/baseComponents/boForm.vue